import { Ng1StateDeclaration } from "@uirouter/angularjs";

export const states: Ng1StateDeclaration[] = [
  {
    name: "gtmhub.automationContactSales",
    data: {
      requiresLogin: true,
      trackingPage: "Automation Contact Sales For Plan Upgrade",
    },
    url: "/automation/contact-sales/",
    template: require("./views/contact-sales.html"),
  },
];
